/** Shorten an address to "0x1234…abcd" for display. */
export function shortAddress(addr: string | null | undefined, head = 6, tail = 4): string {
  if (!addr) return '';
  if (addr.length <= head + tail) return addr;
  return `${addr.slice(0, head)}…${addr.slice(-tail)}`;
}
